<fin-pax-flight-review-summary></fin-pax-flight-review-summary>

<ng-container *ngIf="enableTicketTypeUpselling">
  <fin-upgrade-promotion *ngIf="cartData$ | async"></fin-upgrade-promotion>
</ng-container>

<form class="pax-details flex flex--column grow--min ie--use-100vh" novalidate>
  <fin-booking-plain-header-area
    *ngIf="cartData$ | async"
    [title]="'paxDetails.infoTitle' | finLocalization"
    [subtitle]="infoMessageKey$ | async | finLocalization"
  >
  </fin-booking-plain-header-area>

  <fin-booking-notification
    *ngIf="cartData$ | async"
    [isFullWidth]="false"
    [theme]="NotificationTheme.SUCCESS"
  ></fin-booking-notification>

  <div class="flex-1 grey-25-bg">
    <div *ngIf="(cartData$ | async) === null" class="fill grow--min flex flex--column flex--center">
      <fin-loader [type]="LoaderType.EMBEDDED" title="ticketSelection.loading"></fin-loader>
    </div>
    <ng-container *ngIf="cartData$ | async">
      <fin-login-promotion></fin-login-promotion>
      <fin-pax-details-form
        class="block mobile-bleed"
        [cartStatus$]="cartStatus$"
        [cartData$]="cartData$"
        (ready)="emitReady($event)"
        (infoMessageKey)="setInfoMessage($event)"
        (unlockTravelingWith)="unlockTravelingWith.emit($event)"
      ></fin-pax-details-form>
    </ng-container>
  </div>
</form>
